import { defineType } from 'sanity';

export const heroWithMascot = defineType({
    name: 'heroWithMascot',
    title: 'Hero with Mascot section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'buttonText',
            title: 'Button Text',
            type: 'localizedString',
        },
        {
            name: 'mascotImage',
            title: 'Mascot Image',
            type: 'seoOptimizedImageUrl',
            description: 'URL to the mascot image',
        },
        {
            name: 'floatingSvg',
            title: 'Floating SVG',
            type: 'seoOptimizedImageUrl',
            description: 'URL to the floating SVG elements',
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Hero with Mascot: ${title['en'] || title['sr']}`,
            };
        },
    },
});
